import { SelectLanguageLayer } from './SelectLanguageLayer';
import { AudioManager } from "./../../AudioManager";
import { GameVars } from "./../../GameVars";
import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { Button } from "../../utils/Utils";
import { Title } from "./Title";
import { AudioButton } from "../board-scene/gui/AudioButton";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;
    
    constructor() {

        super("SplashScene");
    }

    public create(): void {

        SplashScene.currentInstance = this;
        GameManager.setCurrentScene(this);

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, 0, "background");
        background.setOrigin(.5, 0);

        const audioButton = new AudioButton(this);
        audioButton.scaleX = GameVars.scaleX;
        audioButton.setPosition(GameConstants.GAME_WIDTH - 40 * GameVars.scaleX, 40);
        this.add.existing(audioButton);

        const midContainer = this.add.container(GameConstants.GAME_WIDTH / 2,  GameConstants.GAME_HEIGHT / 2);
        midContainer.scaleX = GameVars.scaleX;

        const title = new Title(this);
        midContainer.add(title);

        const playButton = new Button(this, 0, 305, "texture_atlas_1", "btn_play_off", "btn_play_on");
        playButton.onDown(this.onPlayDown, this);
        midContainer.add(playButton);

        const selectLanguageLayer = new SelectLanguageLayer(this);
        this.add.existing(selectLanguageLayer);
        
        midContainer.alpha = 0;

        this.tweens.add({
            targets: midContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000
        });

        this.tweens.add({
            targets: playButton,
            y: 280,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500
        });

        if (!this.sys.game.device.os.desktop) { 

            this.input.on("pointerup", function(): void {
                
                this.game.scale.startFullscreen();

                this.scene.time.delayedCall(100, GameManager.setGameScaleX, [], GameManager);

            }, this);
        }

        AudioManager.playSound("intro_splash", true, .5);
    }

    private onPlayDown(): void {

        this.cameras.main.fadeOut(300, 40, 49, 78);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterBoardScene();
        });

        AudioManager.playSound("click");
    }
}
